import * as React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import 'leaflet/dist/leaflet.css'
import 'react-data-grid/lib/styles.css';

import { router } from './App'
// import App from './App'
import "./App.css";


createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);

